module.exports = __webpack_public_path__ + "img/JORNAY_Vector_Charts-2-mobile.6b2d23e7.png";